// @flow
import React, { useContext, Suspense } from 'react';
import ComponentLibrary from 'shared/widgets';
import { DragAndDropContext } from 'shared/components/DragAndDrop';
import type { SubcomponentEditor } from 'shared/components/EditorContext';

import SlotControls from 'shared/editor/Slot/EditorSlot/SlotControls';
import AddComponent from 'shared/editor/Slot/EditorSlot/AddComponent';

type Props = {
  editor: SubcomponentEditor,
  parentId: string,
  component: Object,
  componentIndex: number
};

const EditorSlot = (props: Props) => {
  const {
    editor,
    parentId,
    component,
    componentIndex
  } = props;

  const dragAndDropContext = useContext(DragAndDropContext);

  if (component) {
    const Component = ComponentLibrary[component.widgetId];

    // Render with editor controls
    const cProps = {
      ...component.props,
      _id: component._id,
      subcomponents: component.subcomponents,
      isEditing: true
    };
    const widgetName = Component && Component.schema && Component.schema.title || component.widgetId;

    return (
      <Suspense fallback={<div />}>
        <SlotControls
          component={Component}
          widgetName={widgetName}
          componentProps={cProps}
          {...editor}
          isUsingPresetId={false}
          isSubcomponent
          onDragStart={e => dragAndDropContext.onDragStartHandler(e, { id: component._id, component })}
        />
      </Suspense>
    );
  }

  // Render the empty column, with Add Component in editor
  return (
    <Suspense fallback={<div />}>
      <AddComponent
        slotId="slide-show-content"
        onClick={() => editor.onClickAdd(parentId, componentIndex)}
        onDragEnter={dragAndDropContext.setDropZone}
        onDragOver={dragAndDropContext.setDropZone}
        onDrop={e => dragAndDropContext.onDropHandler(e, { id: parentId, position: componentIndex })}
        onDragEnd={dragAndDropContext.onDragEndHandler}
      />
    </Suspense>
  );
};

export default EditorSlot;
